import { TemplatePlaceHolderControlModel } from './template-placeholder-control.model';
import { TemplateControlType } from '@fi-app/template/types/template-control-type';
import { IFiCustomerData } from '@fi-shared/fi-shared-services/fi-customer-data.service';

export class TemplatePlaceholderModel {
    Id: number;
    TemplateId: number;
    Properties: string;
    ControlCollection: TemplatePlaceHolderControlModel[];
    ControlType: TemplateControlType = TemplateControlType.None;
    constructor(customerData: IFiCustomerData, data?) {
        data = data || {
            ControlCollection: [],
        };

        var self = this;

        this.Id = data.Id;
        this.TemplateId = data.TemplateId;

        this.Properties = '';

        this.ControlCollection = [];
        data.ControlCollection.forEach((control) => {
            self.ControlCollection.push(new TemplatePlaceHolderControlModel(customerData, control));
        });
    }
}
